import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'vObsadaApi/';

export default {

    getObsada() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getObsadaSzukaj(params){
        return axios({
            method: 'get',
            url: URL + params,
        });
    },

    addObsada(data) {
        return axios({
            method: 'post',
            url: URL+'insertObsada',
            data: JSON.stringify(data),
        })
    },

    addObsadaBis(data) {
        return axios({
            method: 'post',
            url: URL+'insertBis',
            data: JSON.stringify(data),
        })
    },

    // tylko id kierowcy i id pojazdu

    editObsada(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    edytujZasobyObsady(id,data){
        return axios(
            {
                url: URL + 'updateObsada/'+id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    zablokujKurs(id,) {
        return axios(
            {
                url: URL +'zablokujKurs/'+ id,
                method: 'put',
             //   data: JSON.stringify(data),
            }
        )
    },
    odblokujKurs(id) {
        return axios(
            {
                url: URL + 'odblokujKurs/'+ id,
                method: 'put',
            //    data: JSON.stringify(data),
            }
        )
    },

    /*deleteObsada(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },*/

    odwolajObsade(id) {
        return axios({
                url: URL + 'odwolajKurs/'+ id,
                method: 'put',
            }
        )
    },

    zamienZasobyObsada(params) {
        return axios({
            method: 'post',
            url: URL+'zamiana'+params,
        })
    },

    generujObsade(data) {
        return axios({
            method: 'post',
            url: URL+'pZrobObsadeKursow',
            data: JSON.stringify(data),
        })
    },

    generujObsadeDlaWszystkichTras(data) {
        return axios({
            method: 'post',
            url: URL+'pZrobObsadeKursowAll',
            data: JSON.stringify(data),
        })
    },


    sprawdzKonfiguracje(params){
        return axios({
            method: 'post',
            url: URL+'pCzyRozklObsTrasa',
            data: JSON.stringify(params),
        })
    },

    sprawdzKonfiguracjeDlaWszystkichTras(params){
        return axios({
            method: 'post',
            url: URL+'pCzyRozklObsAllTr',
            data: JSON.stringify(params),
        })
    },

    sprawdzDokladnaKonfiguracje(data,trasa,rodzaj){
        return axios({
            method: 'get',
            url: URL + 'pCzyRozklObsInfo?data='+data+'&idTr='+trasa+'&rodzaj='+rodzaj,
        });
    },

    odwolajObsadeBis(id) {
        return axios({
                url: URL + 'odwolajBis/'+ id,
                method: 'put',
            }
        )
    },

    przywrocObsadeBis(id) {
        return axios({
                url: URL + 'przywrocBis/'+ id,
                method: 'put',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaService.js